import { gql } from "lib/apolloClient";
import {
  learnerPortfolioFragment,
  learnerPortfolioCollectionFragment,
  organizationResourceFragment,
  subjectFragment,
} from "./LearnerPortfolioFragments";

export const getLearnerPortfolioYearGroupsQuery = gql`
  query getLearnerPortfolioYearGroups(
    $id: ID!
    $type: ENTITY_TYPE_ENUM!
    $curriculumProgramId: ID!
    $filters: LearnerPortfolioFilterInput
  ) {
    node(id: $id, type: $type) {
      id
      ... on Staff {
        learnerPortfolios(
          curriculumProgramId: $curriculumProgramId
          filters: $filters
        ) {
          ...learnerPortfolioItem
        }
      }
    }
  }
  ${learnerPortfolioFragment.learnerPortfolio}
`;

export const getStudentsInLearnerPortfolioYearGroupQuery = gql`
  query getLearnerPortfolioYearGroupStudents(
    $id: ID!
    $type: ENTITY_TYPE_ENUM!
    $filters: StudentLearnerPortfoliosFilter
  ) {
    node(id: $id, type: $type) {
      id
      ... on LearnerPortfolio {
        id
        studentLearnerPortfolios(filters: $filters) {
          ...studentLearnerPortfolioItem
        }
      }
    }
  }
  ${learnerPortfolioFragment.studentLearnerPortfolio}
`;

export const getLearnerPortfolioFoldersQuery = gql`
  query getLearnerPortfolioFolders($id: ID!) {
    node(id: $id, type: STUDENT_LEARNER_PORTFOLIO) {
      id
      ... on StudentLearnerPortfolio {
        id
        student {
          id
          firstName
          lastName
          yearGroup {
            id
            name
          }
        }
        learnerPortfolioResources {
          id
          label
          type
          resourceType
          metadata
          isArchived
          status
          entity {
            id
            ...subjectItem
          }
        }
      }
    }
  }
  ${subjectFragment.subject}
`;

export const getLearnerPortfolioCollectionsQuery = gql`
  query getLearnerPortfolioCollections(
    $id: ID!
    $skipPostData: Boolean!
    $collectionFilters: OrganizationResourceFilter
    $postFilters: OrganizationResourceFilter
  ) {
    node(id: $id, type: ORGANIZATION_RESOURCE) {
      id
      ... on OrganizationResource {
        ...organizationResourceItemCollection
      }
    }
  }
  ${organizationResourceFragment.organizationResourceForCollection}
`;

export const getLearnerPortfolioCollectionsMultiNodeQuery = gql`
  query getLearnerPortfolioCollectionsMultiNode(
    $ids: [ID!]
    $skipPostData: Boolean!
    $collectionFilters: OrganizationResourceFilter
    $postFilters: OrganizationResourceFilter
  ) {
    multiNode(ids: $ids, type: ORGANIZATION_RESOURCE) {
      id
      ... on OrganizationResource {
        ...organizationResourceItemCollection
      }
    }
  }
  ${organizationResourceFragment.organizationResourceForCollection}
`;

export const getLearnerPortfolioCollectionListQuery = gql`
  query getLearnerPortfolioCollectionsList($id: ID!) {
    node(id: $id, type: ORGANIZATION_RESOURCE) {
      id
      ... on OrganizationResource {
        id
        label
        childrenV2 {
          ...collectionLabelItem
        }
      }
    }
  }
  ${learnerPortfolioCollectionFragment.collectionLabel}
`;

export const getLearnerPortfolioFoldersWithCollectionsQuery = gql`
  query getLearnerPortfolioFolders($id: ID!) {
    node(id: $id, type: STUDENT_LEARNER_PORTFOLIO) {
      id
      ... on StudentLearnerPortfolio {
        id
        learnerPortfolioResources {
          id
          label
          type
          resourceType
          metadata
          isArchived
          entity {
            id
            ...subjectItem
          }
          childrenV2 {
            ...collectionListItem
          }
        }
      }
    }
  }
  ${learnerPortfolioCollectionFragment.collectionList}
  ${subjectFragment.subject}
`;

export const getLearnerPortfolioQuery = gql`
  query getLearnerPortfolio(
    $id: ID!
    $type: ENTITY_TYPE_ENUM!
    $filters: ChildLearnerPortfolioInput
  ) {
    node(id: $id, type: $type) {
      id
      ... on Student {
        learnerPortfolio {
          id
        }
      }
      ... on FamilyMember {
        childrenLearnerPortfolio(filters: $filters) {
          id
        }
      }
    }
  }
`;

export const getLearnerPortfolioTagsQuery = gql`
  query getLearnerPortfolioTags(
    $id: ID!
    $filters: LearnerPortfolioTagFilters
  ) {
    node(id: $id, type: STUDENT_LEARNER_PORTFOLIO) {
      id
      ... on StudentLearnerPortfolio {
        id
        tags(input: $filters) {
          id
          name
        }
      }
    }
  }
`;
